import React from 'react';
import EditCustomerInfoForm from '../../../components/client/EditUserInfoForm';
import ClientLayout from '../../../components/client/ClientLayout';
const EditUserInfoPage = () => {
    return (
        <ClientLayout>
            <EditCustomerInfoForm />
        </ClientLayout>
    );
};

export default EditUserInfoPage;
